module.exports = {"content":{},"productInfo":{"code":"{781CC166-DABA-4C37-B420-F751A70143CC}","name":"フィリピン語（タガログ語）　初中級","serialHead":"NVNTS","courseResourceIDs":[{"levelNo":1,"resourceID":"7da110d009a53643e9c840df5d06219d9ddf1117"},{"levelNo":2,"resourceID":"44416fa16464960d99f02fc2de1ce25a5dde68c8"},{"levelNo":3,"resourceID":"612c960fecdf00d18590425668e6e901c1897bb7"}],"language":"tl-PH","challengeCount":21319},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1